<template>
  <v-stepper-content step="7">
    <v-card class="mx-1 mb-12">
      <v-card-title>{{ $t("form.success.headline") }}</v-card-title>
      <v-card-text>{{ $t("form.success.text") }}</v-card-text>
      <v-card-actions>
        <v-btn color="primary" href="/">{{ $t("label.toStartingPage") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-stepper-content>
</template>

<script>
export default {};
</script>

<style>
</style>